<template>
  <div class="myinfo-top">
    <div class="cnt">
      <span class="uicon">
        <img
          :src="userInfo.headImage"
          @mouseover="showAccountSetting()"
          @mouseout="hideAccountSetting()"
        />
        <a class="u-shadow" href="/#/MyAccountSetting" style="display:inline" v-show="showMyAccount" >个人资料</a>
      </span>
      <span class="uicon-info">
        <span class="uicon-name">{{userInfo.userExpand.nickname}}</span>
        <span class="uicon-intro"></span>
      </span>
      <span class="my-to-num"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyAccountHeader",
  components: {},
  data() {
    return {
      showMyAccount: false,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    nav() {
      return this.$store.state.nav;
    },
  },
  methods: {
    showAccountSetting() {
      this.showMyAccount = true;
    },
    hideAccountSetting() {
      this.showMyAccount = false;
    },

  },
};
</script>